export const moduleFiles = require.context("./modules", true, /\.js$/);
export const constantFile = require("./constant").default;
